import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/capacityPerClassSagas";
import ClassTypes from "./smartComponents/сlassTypes";
import PeriodType from "./smartComponents/periodType";
import CustomDateRanges from "./smartComponents/customDateRanges";
import DatePicker from "./smartComponents/datePicker";
import LineChart from "./smartComponents/lineChart";
import { getState } from "./selector-util";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import PercentageDisplay from "../../../../components/percentageDisplay/percentageDisplay";
import "../attendance_common.css.scss";

const CapacityPerClassModule = (props) => {
  const dispatch = useDispatch();
  let {
    filtersDirty,
    isLoading,
    updatesLoading,
    selectedRequestDates: { startDate, endDate },
    currentUser: { qa: isUserQA },
    tilesData: { avg_capacity, avg_attendance, total }
  } = useSelector((state) => getState(state));

  let renderUpdateBtn = () => {
    let checkForInvalidDate = startDate !== "Invalid date" && endDate !== "Invalid date";
    if (filtersDirty && !isLoading && checkForInvalidDate) {
      return (
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>
      );
    }
  };

  let renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      );
    }
  };

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(props.params));
  }, []);

  let content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div>
              <div className="select-box-no-width">
                <p>Class Types</p>
                <ClassTypes />
              </div>
            </div>

            <div className="top-filter__right">
              <div className="select-box-no-width">
                <p>Period Type</p>
                <PeriodType />
              </div>

              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>

              <div className="date-select-box select-box-no-width multi">
                <p>Date</p>
                <DatePicker />
              </div>

              {renderUpdateBtn()}
              {renderResetBtn()}
            </div>
          </div>
          <div className="content">
            {updatesLoading ? (
              <LoadingAnimation text="Updating data..." />
            ) : (
              <>
                <LineChart />
                <div className="content__tiles">
                  <div className="tile">
                    <SectionContainer title="Capacity">
                      <PercentageDisplay value={avg_capacity} disableAnimation={isUserQA} />
                    </SectionContainer>
                  </div>

                  <div className="tile">
                    <SectionContainer title="Average Attendance">
                      <NumberDisplay value={avg_attendance} disableAnimation={isUserQA} />
                    </SectionContainer>
                  </div>

                  <div className="tile">
                    <SectionContainer title="Total Class Attendance">
                      <NumberDisplay value={total} disableAnimation={isUserQA} />
                    </SectionContainer>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div id="attendance-root" className="capacity-per-class">
      <SectionToggle autoHeight paddingBottom={0} title="Capacity per Class" isLoading={isLoading} content={content()} />
    </div>
  );
};

CapacityPerClassModule.propTypes = {
  params: PropTypes.object
};

export default CapacityPerClassModule;
